var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"VideoDemo"}},[_c('videoPlayer',{ref:"videoPlayer",attrs:{"title":_vm.title,"options":_vm.options},on:{"titleClick":_vm.titleClick,"ready":_vm.ready}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }